import { FPS } from '../../constants';

export const msToFrame = (ms: number) => {
  return Math.floor((ms / 1000) * FPS);
};
